import React from 'react'

type Props = {
    title?: string
    className?: string
}

const TemplateDocumentIcon: React.FC<Props> = () => (
    <svg
        style={{ marginRight: '12px' }}
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
            d="M12.6555 33.9893H32.9404C33.1328 33.9893 33.2902 33.8319 33.2902 33.6396V13.0049H27.3446C26.7661 13.0049 26.2954 12.5341 26.2954 11.9556V6.01003H12.6555C12.4631 6.01003 12.3057 6.16741 12.3057 6.35977V33.6396C12.3057 33.8319 12.4631 33.9893 12.6555 33.9893Z"
            fill="white"
        />
        <path
            d="M32.7957 12.3054L26.9948 6.50456V11.9556C26.9948 12.148 27.1522 12.3054 27.3446 12.3054H32.7957Z"
            fill="white"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M33.6819 12.2032L27.097 5.61762C26.8998 5.4217 26.6334 5.31137 26.3555 5.31055H12.6555C12.077 5.31055 11.6062 5.7813 11.6062 6.35977V33.6396C11.6062 34.2181 12.077 34.6888 12.6555 34.6888H32.9404C33.5189 34.6888 33.9897 34.2181 33.9897 33.6396V12.9447C33.9897 12.6649 33.8805 12.4012 33.6819 12.2032ZM26.9948 6.50456L32.7957 12.3054H27.3446C27.2519 12.3052 27.163 12.2683 27.0975 12.2027C27.0319 12.1372 26.995 12.0483 26.9948 11.9556V6.50456ZM12.6555 33.9893H32.9404C33.1328 33.9893 33.2902 33.8319 33.2902 33.6396V13.0049H27.3446C26.7661 13.0049 26.2954 12.5341 26.2954 11.9556V6.01003H12.6555C12.4631 6.01003 12.3057 6.16741 12.3057 6.35977V33.6396C12.3057 33.7323 12.3426 33.8213 12.4082 33.8869C12.4737 33.9525 12.5627 33.9893 12.6555 33.9893Z"
            fill="#605E5C"
        />
        <path
            d="M30.842 24.1966H22.798V24.8961H30.842C30.9348 24.8961 31.0237 24.8592 31.0893 24.7936C31.1549 24.728 31.1917 24.6391 31.1917 24.5463C31.1917 24.4536 31.1549 24.3646 31.0893 24.299C31.0237 24.2334 30.9348 24.1966 30.842 24.1966Z"
            fill="#103F91"
        />
        <path
            d="M30.842 22.0981H22.798V22.7976H30.842C30.9348 22.7976 31.0237 22.7608 31.0893 22.6952C31.1549 22.6296 31.1917 22.5406 31.1917 22.4479C31.1917 22.3551 31.1549 22.2661 31.0893 22.2006C31.0237 22.135 30.9348 22.0981 30.842 22.0981Z"
            fill="#185ABD"
        />
        <path
            d="M30.842 19.9997H22.798V20.6992H30.842C30.9348 20.6992 31.0237 20.6623 31.0893 20.5967C31.1549 20.5311 31.1917 20.4422 31.1917 20.3494C31.1917 20.2567 31.1549 20.1677 31.0893 20.1021C31.0237 20.0365 30.9348 19.9997 30.842 19.9997Z"
            fill="#2B7CD3"
        />
        <path
            d="M30.842 17.9012H22.798V18.6007H30.842C30.9348 18.6007 31.0237 18.5639 31.0893 18.4983C31.1549 18.4327 31.1917 18.3437 31.1917 18.251C31.1917 18.1582 31.1549 18.0693 31.0893 18.0037C31.0237 17.9381 30.9348 17.9012 30.842 17.9012Z"
            fill="#41A5EE"
        />
        <path
            d="M7.40934 29.0929H20C20.371 29.0929 20.7269 28.9456 20.9892 28.6832C21.2516 28.4208 21.399 28.065 21.399 27.694V15.1033C21.399 14.7323 21.2516 14.3764 20.9892 14.1141C20.7269 13.8517 20.371 13.7043 20 13.7043H7.40934C7.03831 13.7043 6.68248 13.8517 6.42012 14.1141C6.15777 14.3764 6.01038 14.7323 6.01038 15.1033V27.694C6.01038 28.065 6.15777 28.4208 6.42012 28.6832C6.68248 28.9456 7.03831 29.0929 7.40934 29.0929Z"
            fill="#185ABD"
        />
        <path
            d="M11.4866 23.7223C11.5097 23.9056 11.5251 24.0651 11.5321 24.2008H11.5587C11.5901 23.8888 11.6405 23.5782 11.7084 23.2719L12.9499 17.9012H14.5553L15.8395 23.1921C15.9039 23.453 15.957 23.7853 16.0004 24.1896H16.0214C16.0396 23.9105 16.0843 23.5887 16.155 23.2243L17.1832 17.9012H18.6437L16.8461 25.5955H15.1386L13.9131 20.4984C13.8775 20.3515 13.8369 20.1599 13.7928 19.9234C13.759 19.7529 13.7313 19.5811 13.7096 19.4086H13.6886C13.6746 19.5345 13.6466 19.7206 13.6054 19.9668C13.5641 20.2144 13.5312 20.3956 13.5067 20.5145L12.3561 25.5955H10.6221L8.80831 17.9012H10.2961L11.4139 23.283C11.4391 23.3943 11.4628 23.5412 11.4866 23.7223Z"
            fill="#F9F7F7"
        />
    </svg>
)

export default TemplateDocumentIcon
